export enum ObjectType {
  SPREADSHEET = 'spreadsheet',
  TEXTAREA = 'textarea',
}

export interface StyleType {
  before?: string;
  after?: string;
}

export enum ObjectAlignOptions {
  LEFT = 'float-left',
  RIGHT = 'float-right',
  CENTER = 'ml-auto mr-auto',
}

export enum FontChangeOption {
  BOLD = 'font-bold',
  UNDERLINE = 'underline',
}

export enum FontSizeOption {
  PX_12 = '12',
  PX_14 = '14',
  PX_16 = '16',
  PX_18 = '18',
  PX_24 = '24',
}

export enum StructureOption {
  ADD_ROW = 'add-row',
  ADD_COLUMN = 'add-column',
  REMOVE_ROW = 'remove-row',
  REMOVE_COLUMN = 'remove-column',
}

export enum Target {
  BACKGROUND = 'bg',
  TEXT = 'text',
}

export interface Cell {
  value: any;
  className: string;
}
